const commonMeta = {
  robots: "noindex, nofollow",
};

export const homeMeta = {
  en: {
    title: "Canada Auto Parts Online – OEM & Aftermarket Parts | Parts Avatar",
    image: "https://partsavatar.ca/cms/home/banners/images/3-replacement-auto-parts-for-every-repair--partsavatar-car-prices-are-lower-than-rockauto.com--carid.com--autopartsway.ca--partsource.ca--VL-comp.png",
    description:
      "PartsAvatar is Canada’s largest online auto parts store, offering parts for all makes and models at the lowest prices in Canada. Shop over 3 million quality parts with fast, free shipping on orders above $99+ across Canada.",
    meta: {
      robots: "all",
      name: {
        title: "Best Aftermarket Parts for Car, Jeep, SUV, Truck",
        keywords:
          "Wholesale auto parts Canada online, Cheap auto parts Canada online, Best auto parts Canada online, best online discount auto parts, car parts Canada, Discount auto parts Canada online, used car parts Canada, aftermarket auto parts Canada, best online auto parts Canada, cheap auto parts Canada, auto parts near me, auto parts online Canada",
      },
    },
  },
  fr: {
    title: "Parts Avatar : Pièces d'auto et de camion en ligne au Canada",
    image: "https://partsavatar.ca/cms/home/banners/images/3-replacement-auto-parts-for-every-repair--partsavatar-car-prices-are-lower-than-rockauto.com--carid.com--autopartsway.ca--partsource.ca--VL-comp.png",
    description:
      "PartsAvatar est le leader des magasins de vente au détail en ligne de pièces détachées automobiles au Canada avec un large choix de pièces automobiles, de pièces de carrosserie, d'accessoires de performance et d'outils de réparation",
    meta: {
      robots: "all",
      name: {
        title: "Meilleures pièces de rechange pour voiture, Jeep, SUV, camion",
        keywords:
          "pièces, auto, voiture, SUV, camion, jeep, véhicule, réparation, aftermarket, en ligne, canada, performance, pièces de carrosserie, accessoires auto, accessoires de voiture, trouver des pièces auto, rechercher des pièces auto, acheter des pièces auto, pièces auto bon marché, pièces auto européennes, pièces auto japonaises",
      },
    },
  },
};

export const shoppingCartMeta = {
  en: {
    title: "PartsAvatar.ca: Your Shopping Cart",
    description: "",
    meta: commonMeta,
  },
  fr: {
    title: "PartsAvatar.ca: Votre panier d'achat",
    description: "",
    meta: commonMeta,
  },
};

export const checkoutS1Meta = {
  en: {
    title: "PartsAvatar.ca: Sign In",
    description: "",
    meta: {
      robots: "noindex, nofollow",
    },
  },
  fr: {
    title: "PartsAvatar.ca: Se Connecter",
    description: "",
    meta: {
      robots: "noindex, nofollow",
    },
  },
};

export const checkoutS2Meta = {
  en: {
    title: "PartsAvatar.ca: Enter your Delivery Address",
    description: "",
    meta: commonMeta,
  },
  fr: {
    title: "PartsAvatar.ca: Entrez votre adresse de livraison",
    description: "",
    meta: commonMeta,
  },
};

export const checkoutS3Meta = {
  en: {
    title: "PartsAvatar.ca: Enter your Payment Information",
    description: "",
    meta: commonMeta,
  },
  fr: {
    title: "PartsAvatar.ca: Saisissez vos Informations de Paiement",
    description: "",
    meta: commonMeta,
  },
};

export const checkoutS4Meta = {
  en: {
    title: "PartsAvatar.ca: Please review and confirm your order",
    description: "",
    meta: commonMeta,
  },
  fr: {
    title: "PartsAvatar.ca: Veuillez vérifier et confirmer votre commande",
    description: "",
    meta: commonMeta,
  },
};
